import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { currencyFormat } from '../../../../../../../utils/Helper'
import BuyoutPriceField from './BuyoutPriceField'
import BuyoutSwitch from './BuyoutSwitch'
import ImpressionField from './ImpressionField'
import KsaSwitch from './KsaSwitch'
import AdvertiserMarginField from './AdvertiserMarginField'
import PayoutPriceField from './PayoutPriceField'
import ActionButtonDropdown from './MediaActionParts/ActionButtonDropdown'
import InfluencerPayoutMarginField from './InfluencerPayoutMarginField'
import AdvertiserPriceField from './AdvertiserPriceField'

export default observer(function MediaAction({ action, campaignScenario }) {
  const { campaign } = useContext(CampaignContext)

  return (
    <tr className="dark:bg-rb-dark-mode dark:border-b dark:border-rb-dark-mode-lighter">
      <td className="p-2 text-xs text-center align-middle font-bold dark:text-white">
        <div className="flex items-center justify-between">
          <p className="">
            {action.name}
          </p>
          <ActionButtonDropdown action={action} campaignScenario={campaignScenario} />
        </div>
      </td>
      <td className="py-2 pr-7 text-xs align-middle font-bold w-[100px] dark:text-white"><PayoutPriceField action={action} /></td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.influencerPrice.toFixed(2), campaign.currency_symbol)}</td>
      {/* <td className="p-2 text-xs align-middle font-bold"><KsaSwitch action={action} /></td>
      <td className="py-2 mx-6 text-xs align-middle font-bold">{currencyFormat(action.ksaPrice.toFixed(2), campaign.currency_symbol)}</td> */}
      <td className="py-2 pr-7 text-xs align-middle font-bold w-[100px] dark:text-white"><AdvertiserPriceField action={action} /></td>
      {/* <td className="py-2 mx-6 text-xs align-middle font-bold">{currencyFormat(action.advertiserPrice.toFixed(2), campaign.currency_symbol)}</td> */}
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserFollowerCPM.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserImpressionCPM.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 pr-3 text-xs align-middle font-bold w-[100px] dark:text-white"><ImpressionField action={action}/></td>
      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white"><BuyoutSwitch action={action} /></td>
      <td className="py-2 pr-7 text-xs align-middle font-bold min-w-[100px] dark:text-white"><BuyoutPriceField action={action} /></td>
      {/* <td className="p-2 text-xs align-middle font-bold">{currencyFormat(action.buyoutKsaPrice.toFixed(2), campaign.currency_symbol)}</td> */}

      <td className="py-2 mx-6 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.buyoutAdvertiserPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="py-2 mx-6 text-xs align-middle font-bold min-w-28 dark:text-white">
        <div className="flex">
          <KsaSwitch action={action} />
          <p className="ml-2">
            {currencyFormat(action.totalKsaPrice.toFixed(2), campaign.currency_symbol)}
          </p>
        </div>
      </td>
      <td className="p-2 pr-3 text-xs align-middle font-bold min-w-[75px] dark:text-white"><InfluencerPayoutMarginField action={action} /></td>
      <td className="p-2 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.influencerPayoutMarginPrice.toFixed(2), campaign.currency_symbol)}</td>
      <td className="p-2 pr-3 text-xs align-middle font-bold min-w-[90px] dark:text-white"><AdvertiserMarginField action={action} /></td>
      <td className="p-2 text-xs align-middle font-bold dark:text-white">{currencyFormat(action.advertiserMarginPrice.toFixed(2), campaign.currency_symbol)}</td>
    </tr>
  )
})